// All config fields are nested under this namespace
import { POLICY_APPLICATIONS } from '@kentik/ui-shared/alerting/constants';

export const ROOT_NAMESPACE = 'unifiedPolicy';

// Namespaces for policy type sub configs
export const NMS_NAMESPACE = `${ROOT_NAMESPACE}.nms`;
export const KEVENT_NAMESPACE = `${ROOT_NAMESPACE}.kevent`;
export const FLOW_NAMESPACE = `${ROOT_NAMESPACE}.flow`;

// Wizard section / form-options group IDs.
// Shared between each policy type's getFormGroups() and the unified form's sections + getUnifiedPolicyFormOptions().
export const FORM_SECTIONS = Object.freeze({
  GENERAL: 'general',
  DATASET: 'dataset',
  THRESHOLDS: 'thresholds',
  BASELINE: 'baseline',
  FLOW_OPTIONAL: 'flowOptional'
});

export const FORM_SECTION_LABELS = Object.freeze({
  [FORM_SECTIONS.GENERAL]: 'General',
  [FORM_SECTIONS.DATASET]: 'Dataset',
  [FORM_SECTIONS.THRESHOLDS]: 'Activate & Clear',
  [FORM_SECTIONS.BASELINE]: 'Baseline',
  [FORM_SECTIONS.FLOW_OPTIONAL]: 'Dashboards & Labels'
});

/**
 * Target types — the granular values the user selects in the "Policy Type" dropdown.
 *
 * NMS target types (interface, device, etc.) are dynamic and come from $metrics.entityTypeOptions,
 * so common entities are listed here.
 *
 * Note: DDOS, CORE, and METRIC reuse their POLICY_APPLICATIONS values directly.
 * This means targetType === policyApplication for most flow-based policies, which is coincidental.
 * For NMS, the targetType (e.g., 'interface') differs from the policyApplication ('nms').
 * Always use targetTypeToPolicyApplication() to convert rather than assuming equivalence.
 */
export const TARGET_TYPES = {
  ENTITY: 'entity',
  EVENT: 'event',
  CUSTOM: 'custom',
  DDOS: POLICY_APPLICATIONS.DDOS,
  CORE: POLICY_APPLICATIONS.CORE,
  METRIC: POLICY_APPLICATIONS.METRIC
};

export const TARGET_TYPE_DESCRIPTIONS = {
  agent: 'Agent health (resource usage, status)',
  agent_capability: 'Capability health (enablement, status)',
  bgpneighbor: 'BGP peering session states and metrics (session state changes, advertised prefixes)',
  component: 'Device component states and metrics (CPU, power supply)',
  device: 'System-level device states and metrics (up/down status, CPU/memory)',
  interface: 'Interface states and counter metrics (oper status, traffic spikes)',
  [TARGET_TYPES.CORE]: 'NetFlow/VPC FlowLog traffic patterns (flow rate thresholds, fluctuations)',
  [TARGET_TYPES.DDOS]: 'Traffic patterns indicating potential attacks (SYN floods, amplified reflections)',
  [TARGET_TYPES.METRIC]: 'Rolling window aggregations and classic baselines (average over time thresholds)',
  [TARGET_TYPES.EVENT]: 'SNMP traps or syslog messages via regex filters',
  [TARGET_TYPES.CUSTOM]: 'Any NMS measurement including cloud and custom metrics from integrations'
};
